import React, { useRef, useEffect } from 'react';
import { CoreLink } from '@uncinc/react-drupal-core';

const ArticlePrevNext = (props) => {
  const ref = useRef(null);
  const { display } = props;
  const viewIsLoaded = useRef(null);
  let { entities } = props;

  useEffect(() => {
    if (ref.current) {
      if (viewIsLoaded.current) {
        ref.current.scrollIntoView();
      } else {
        viewIsLoaded.current = true;
      }
    }
  }, [ref]);

  if (display === 'prev' && entities.size === 0) {
    entities = null;
  } else if (display === 'next' && entities.size === 0) {
    entities = null;
  }

  return (
    <div ref={ref}>
      <div className="row">
        {entities !== null ? entities.map((entity, index) => {
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const title = entity.getIn(['title', 0, 'value'], '');
          const path = entity.getIn(['paths', 'nl'], '');
          const { pathname } = window.location;

          if (pathname === path) return null;

          return (
            <div key={uuid} className="col-lg-12 spacing-top">
              <CoreLink to={path}>
                <h2>{title}</h2>
                <i className={`icon icon-arrow-right-filled ${display === 'prev' ? 'flipped' : ''}`} />
              </CoreLink>
            </div>
          );
        }) : null}
      </div>
    </div>
  );
};

export default ArticlePrevNext;
